import { useEffect, useRef, useState } from 'react';
import styles from './MailMenu.module.scss';
import { IconWrapper } from '../../../../Atoms/icons/Icon';
import { handleExport } from '../../../../../utils/ExportFuntion';

const MailMenu = ({
  setMailsType,
  exportData,
  setSelectedMail,
  setSelectedItem,
}) => {
  const dropdownRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState({
    label: 'Inbox',
    folder: 'Inbox',
  });

  const optionItems = [
    {
      label: 'Inbox',
      folder: 'Inbox',
    },
    { label: 'Sent', folder: 'sentitems' },
    { label: 'Archive', folder: 'deleteditems' },
    { label: 'Export', type: 'export' },
  ];

  const handleSelect = (option) => {
    setMailsType(option.folder);
    setSelected(option);
    setIsOpen(false);
    setSelectedMail(null);
    setSelectedItem([]);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.dropdownContainer} ref={dropdownRef}>
      <div className={styles.dropdownHeader} onClick={() => setIsOpen(!isOpen)}>
        <span>{selected.label}</span>
        <IconWrapper icon='chevronUp' className={styles.icon} />
      </div>

      {isOpen && (
        <div className={styles.dropdownMenu}>
          {optionItems.map((option) => (
            <div
              key={option.folder}
              className={`${styles.dropdownItem} ${
                selected.folder === option.folder ? styles.active : ''
              }`}
              onClick={() =>
                option.type == 'export'
                  ? handleExport(exportData)
                  : handleSelect(option)
              }
            >
              {selected.folder === option.folder && <span>✔</span>}
              <span>{option.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MailMenu;
